var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanTrabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "213.000000pt",
    viewBox: "0 0 256.000000 213.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,213.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 2051 c-274 -24 -386 -117 -432 -358 -10 -51 -13 -214 -13 -643 0 -507 2 -584 18 -650 48 -211 156 -295 413 -321 63 -6 408 -9 920 -6 724 3 826 5 881 20 180 48 257 129 301 319 14 64 17 143 17 638 0 409 -3 585 -13 637 -35 206 -124 304 -317 350 -62 14 -166 16 -880 18 -445 2 -848 0 -895 -4z m281 -594 c145 -95 326 -215 401 -265 76 -51 142 -92 148 -92 6 0 86 50 178 112 528 353 633 418 676 418 77 0 139 -62 139 -140 0 -77 -8 -84 -453 -380 -230 -153 -436 -283 -457 -289 -49 -14 -117 -14 -166 0 -21 6 -227 136 -457 289 -445 296 -453 303 -453 380 0 78 62 140 139 140 37 0 71 -19 305 -173z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTrabajo);
export default __webpack_public_path__ + "static/media/plan_trabajo.1639428d9d9ba71e2829eca5493f4489.svg";
export { ForwardRef as ReactComponent };